<template>
  <v-container>
    <h1 class="mb-4">作ったサイト</h1>
    <v-layout row wrap justify-start>
      <v-flex xs12 sm4 pa1 v-for="(site, i) in websites" :key="i" class="pa-2">
        <v-card class="mb-4">
          <a v-if="!site.close" :href="site.url" target="_blank">
            <v-img :src="site.image" aspect-ratio="1"></v-img>
          </a>
          <div v-else>
            <v-img :src="site.image" aspect-ratio="1"></v-img>
          </div>

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{site.name}}</h3>
              <div>{{ site.description }}</div>
              <div>{{ site.teck }}</div>
            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn v-if="!site.close" flat block color="orange" :href="site.url" target="_blank">見る</v-btn>
            <v-btn v-else flat block color="black" href="javascript: void(0);">閉鎖</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    websites: [
      {
        image: require("../assets/nobilabo.png"),
        name: "blog",
        teck: "PHP WordPress",
        url: "https://lab.nobi.site/",
        description: "ブログ"
      },
      {
        image: require("../assets/cowoo.png"),
        name: "cowoo",
        teck: "PHP Laravel MySQL",
        url: "https://cowoo.shop/",
        description: "ドロップシッピング",
        close: true
      },
      {
        image: require("../assets/sozai.png"),
        name: "のびのびそざい",
        teck: "WordPress Vue.js",
        url: "https://sozai.nobi.site/",
        description: "フリー素材"
      },
      {
        image: "https://dummy.nobi.site/512/512/NO%20IMAGE?bg=7957d5&fg=FFFFFF&fsize=48&font=Noto%20Sans%20JP&weight=Black",
        name: "のびのびツールズ",
        teck: "Nuxt.js",
        url: "https://tools.nobi.site/",
        description: "WEB制作ツールとか"
      },
      {
        image: "https://dummy.nobi.site/512/512/%E3%83%80%E3%83%9F%E3%83%BC%E7%94%BB%E5%83%8F%E7%94%9F%E6%88%90%E3%81%99%E3%82%8B%E3%82%84%E3%81%A4?bg=ffdd57&fg=333333&fsize=36&font=Noto%20Sans%20JP&weight=Black",
        name: "ダミー画像生成するやつ",
        teck: "Nuxt.js",
        url: "https://dummy.nobi.site/",
        description: "フリー素材"
      },
      {
        image: "https://dummy.nobi.site/512/512/%E3%81%AE%E3%81%B3%E3%81%AE%E3%81%B3%E3%81%AE%E3%83%BC%E3%81%A8?bg=ff69b4&fg=FFFFFF&fsize=40&font=M%2B%202p&weight=Black",
        name: "のびのびのーと",
        teck: "Hugo NetlifyCMS",
        url: "https://note.nobi.site/",
        description: "雑記"
      },
      {
        image: require("../assets/littlebitcode.png"),
        name: "LittleBitCode",
        teck: "hugo",
        url: "https://little-bit-code.work/",
        description: "短いコードと説明"
      },
      {
        image: "https://dummy.nobi.site/512/512/CSS%20%E2%86%92%20SCSS%20%0A%E5%A4%89%E6%8F%9B%E3%81%99%E3%82%8B%E3%82%84%E3%81%A4?bg=FFFFFF&fg=272343&fsize=56&font=Noto%20Sans%20JP&weight=Black",
        name: "CSS → SCSS 変換するやつ",
        teck: "Next.js",
        url: "https://css2scss.nobi.site/",
        description: "WEB制作ツール"
      }
    ]
  })
};
</script>

<style lang="scss">
.v-card {
  &:hover {
    // opacity: 0.65;
  }
}
</style>